import { authenticationReducer as reducer } from './reducer';
import { NAME as namespace } from './constants';
import Routes from './Routes';
export var AuthenticationRoutes = Routes;
export var authentication = {
  namespace: namespace,
  reducer: reducer
};